import { SubdimensionVisitMetrics } from '@components/Dashboard/dashboardSlice/schemas/lci3Reports';
import { Subdimension } from './dimensions';
import {
  convertSlugToDimensionName,
  FullDimensionName,
  validDimensionSlug,
} from '@features/reports/domain';

export type Performers = {
  top: Subdimension[];
  bottom: Subdimension[];
};

export type TopBottomPerformer = Partial<
  Record<FullDimensionName | 'All Dimensions', Performers>
>;

export const getTopAndBottomPerformers = (
  subdimensions: Subdimension[],
  rankBy: keyof SubdimensionVisitMetrics,
  performerCount: number
) => {
  const groupedByDimension = _.groupBy(subdimensions, 'name');

  return Object.entries(groupedByDimension).reduce(
    (acc, [name, subdimensions]) => {
      if (!validDimensionSlug(name)) return acc;

      const sortedSubdimensions = subdimensions.toSorted((a, b) => {
        const aValue = a.visitMetrics[rankBy];
        if (aValue === null) return 1;

        const bValue = b.visitMetrics[rankBy];
        if (bValue === null) return -1;

        return bValue - aValue;
      });
      const top = sortedSubdimensions.slice(0, performerCount);
      const bottom = sortedSubdimensions.slice(-performerCount);

      return {
        ...acc,
        [convertSlugToDimensionName(name)]: {
          top,
          bottom,
        },
      };
    },
    {} as TopBottomPerformer
  );
};
